
export default {
    props: {
        link: String
    }
}
